import type { BtlPurpose } from 'api/btlApplicationForm/types';

/**
 * Mirrors strideup-be `calculateMarketValue`:
 * - no valuation amount → purchasePrice
 * - REFINANCE → valuationAmount
 * - PURCHASE → min(purchasePrice, valuationAmount)
 */
export function calculateOoMarketValue(
  purchasePrice: number | undefined,
  valuationAmount: number | undefined,
  purpose: BtlPurpose | undefined,
): number | undefined {
  if (!purchasePrice) {
    return undefined;
  }

  if (!valuationAmount) {
    return purchasePrice;
  }

  if (purpose === 'REFINANCE') {
    return valuationAmount;
  }

  return Math.min(purchasePrice, valuationAmount);
}

export function formatOoAffordabilityFtv(
  financingAmount: number | undefined,
  propertyValue: number | undefined,
): string | undefined {
  if (financingAmount === undefined || propertyValue === undefined || propertyValue === 0) {
    return undefined;
  }

  return `${Math.round((financingAmount / propertyValue) * 100)}%`;
}
